import React, { Suspense } from "react"
import { Environment } from "@react-three/drei"

import SpineModel from "./components/SpineModel";
import SpineWireframe from "./components/SpineWireframe";
import StickerModel from "./components/StickerModel";
import VariableLight from "./components/VariableLight";

export default function Experience() {
  return (
    <>  
      <directionalLight position={[0, 5, 6]} intensity={4.5} />
      <ambientLight intensity={2} />
      <Environment files="envMap.jpg" environmentIntensity={2} />
      <VariableLight />
      <StickerModel />
      <Suspense fallback={<SpineWireframe/>}>
        <SpineModel />
      </Suspense >
    </>
  );
}
